export enum AvailableTokens {
    REV = "REV", // deprecated
    ASI = "ASI",
}

export const CURRENT_TOKEN = AvailableTokens.ASI;